module.exports = __webpack_public_path__ + "static/media/industry_hover.8862aa52.svg";